<template>

  <v-dialog v-if="itemInfo" v-model="isVisible" 
    fullscreen hide-overlay >
    <v-card color="blue-grey darken-4">
      <v-toolbar dark color="primary">
        <v-layout>
          <v-flex xs1 md1>
            <v-btn icon dark @click="closeDialog()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
          <v-flex class="text-xs-center">
            <v-btn class="warning" dark text @click="zoom(0.2)">放大</v-btn>
            <v-btn class="warning" dark text @click="zoom(-0.2)">縮小</v-btn>
            <v-btn class="warning" dark text @click="rotate(-90)">向左旋轉</v-btn>
            <v-btn class="warning" dark text @click="rotate(90)">向右旋轉</v-btn>
            <v-btn class="red" dark text @click="reset">重置</v-btn>
          </v-flex>
          <v-flex xs1 md1>
            <v-btn class="success" dark flat @click="cropImage">裁切</v-btn>
          </v-flex>
        </v-layout>
      </v-toolbar>
      <v-card-text >        
          <div class="content">
            <section class="cropper-area">
              <div class="img-cropper">
                <vue-cropper
                  ref="cropper"                  
                  :src="itemInfo.file_body_encode"
                  :checkCrossOrigin="true"
                  preview=".preview"
                />
              </div>
              <!-- <div class="actions">
                <a
                  href="#"
                  role="button"
                  @click.prevent="zoom(0.2)"
                >
                  Zoom In
                </a>
                <a
                  href="#"
                  role="button"
                  @click.prevent="zoom(-0.2)"
                >
                  Zoom Out
                </a>
                <a
                  href="#"
                  role="button"
                  @click.prevent="move(-10, 0)"
                >
                  Move Left
                </a>
                <a
                  href="#"
                  role="button"
                  @click.prevent="move(10, 0)"
                >
                  Move Right
                </a>
                <a
                  href="#"
                  role="button"
                  @click.prevent="move(0, -10)"
                >
                  Move Up
                </a>
                <a
                  href="#"
                  role="button"
                  @click.prevent="move(0, 10)"
                >
                  Move Down
                </a>
                <a
                  href="#"
                  role="button"
                  @click.prevent="rotate(90)"
                >
                  Rotate +90deg
                </a>
                <a
                  href="#"
                  role="button"
                  @click.prevent="rotate(-90)"
                >
                  Rotate -90deg
                </a>
                <a
                  ref="flipX"
                  href="#"
                  role="button"
                  @click.prevent="flipX"
                >
                  Flip X
                </a>
                <a
                  ref="flipY"
                  href="#"
                  role="button"
                  @click.prevent="flipY"
                >
                  Flip Y
                </a>
                <a
                  href="#"
                  role="button"
                  @click.prevent="cropImage"
                >
                  Crop
                </a>
                <a
                  href="#"
                  role="button"
                  @click.prevent="reset"
                >
                  Reset
                </a>
                <a
                  href="#"
                  role="button"
                  @click.prevent="getData"
                >
                  Get Data
                </a>
                <a
                  href="#"
                  role="button"
                  @click.prevent="setData"
                >
                  Set Data
                </a>
                <a
                  href="#"
                  role="button"
                  @click.prevent="getCropBoxData"
                >
                  Get CropBox Data
                </a>
                <a
                  href="#"
                  role="button"
                  @click.prevent="setCropBoxData"
                >
                  Set CropBox Data
                </a>
                <a
                  href="#"
                  role="button"
                  @click.prevent="showFileChooser"
                >
                  Upload Image
                </a>
              </div> -->
            </section>
          </div>

        <!-- <div style="height:400px;">
          <vue-cropper
            ref="cropper"
            :src="itemInfo.file_body_encode"
            alt="Source Image"
            @ready="readyEvent"
            @cropstart="cropstartEvent"
            @cropmove="cropmoveEvent"
            @cropend="cropendEvent"
            @crop="cropEvent"
            @zoom="zoomEvent"
          >
          </vue-cropper>
        </div> -->
        
        <v-card-actions>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog> 
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  props:['imageItem'],
  name:'ImageEditorView',
  components: {
    VueCropper,
  },
  props:{
    imageItem:Object,
    visible: Boolean,
  },
  data() {
    return {
      cropImg: '',
      data: null,
      isVisible:false,
      itemInfo:null,
    }
  },
  watch:{
    visible(value){
      if(value) {
        this.isVisible = value
      }
    },
    imageItem(value){
      if(!this.itemInfo) {
        this.itemInfo = value;
      } else {
        this.replaceImage(value);
      }
    },
    isVisible(value){
      if(!value) {
        this.$emit('closeEvent');
      }
    }
  },
  mounted(){
  },
  updated(){
    
  },
  created(){
  },
  methods: {
    replaceImage(file) {
      this.itemInfo = file;
      this.$refs.cropper.replace(this.itemInfo.file_body_encode);
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      let info = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.itemInfo.file_body_encode = info;
      this.isVisible = false;
      this.$emit('cropperEvent',this.itemInfo);
    },
    flipX() {
      const dom = this.$refs.flipX;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleX(scale);
      dom.setAttribute('data-scale', scale);
    },
    flipY() {
      const dom = this.$refs.flipY;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleY(scale);
      dom.setAttribute('data-scale', scale);
    },
    getCropBoxData() {
      this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4);
    },
    getData() {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    reset() {
      this.$refs.cropper.reset();
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    setCropBoxData() {
      if (!this.data) return;
      this.$refs.cropper.setCropBoxData(JSON.parse(this.data));
    },
    setData() {
      if (!this.data) return;
      this.$refs.cropper.setData(JSON.parse(this.data));
    },
    showFileChooser() {
      this.$refs.input.click();
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    closeDialog(){
      // this.$refs.cropper.destroy();
      this.isVisible = false;
    },
    confirmEvent(){
      this.isVisible = false;
    },
    readyEvent() {
      // this.$refs.cropper.setCropBoxData().width = 200;
      // this.$refs.cropper.viewMode(1);
      // this.cropper[method](argument1, , argument2, ..., argumentN);
      // this.$refs.cropper.move(1, -1);
      // const containerData = this.$refs.cropper.getContainerData();

      // this.$refs.cropper.zoomTo(.5, {
      //   x: containerData.width / 2,
      //   y: containerData.height / 2,
      // });

      // Allows chain composition
      // this.cropper.move(1, -1).rotate(45).scale(1, -1);
    },
    cropstartEvent(){

    },
    cropmoveEvent(){

    },
    cropendEvent(){

    },
    cropEvent(){

    },
    zoomEvent(){
      
    },  
  }
}
</script>

<style scoped>
.content {
  display: flex;
  justify-content: center;
}
.cropper-area {
  width: 614px;
}
.actions {
  margin-top: 1rem;
}
.actions a {
  display: inline-block;
  padding: 5px 15px;
  background: #0062CC;
  color: white;
  text-decoration: none;
  border-radius: 3px;
  margin-right: 1rem;
  margin-bottom: 1rem;
}
textarea {
  width: 100%;
  height: 100px;
}
.preview-area {
  width: 307px;
}
.preview-area p {
  font-size: 1.25rem;
  margin: 0;
  margin-bottom: 1rem;
}
.preview-area p:last-of-type {
  margin-top: 1rem;
}
.preview {
  width: 100%;
  height: calc(372px * (9 / 16));
  overflow: hidden;
}
.crop-placeholder {
  width: 100%;
  height: 200px;
  background: #ccc;
}
.cropped-image img {
  max-width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/ImageEditorView.vue